// @flow
import './PremiumBreakdownRow.scss';

import PropTypes from 'prop-types';
import React from 'react';

import { getFormattedCurrencyNumber } from '../../../utils/utils';

interface PremiumBreakdownRowProps {
  label: string;
  price?: number;
  suffix?: string;
  bold?: boolean;
  textValue?: string;
  showSecondColumn?: boolean;
}



const PremiumBreakdownRow = (props: PremiumBreakdownRowProps) => {
  const className = 'c-PremiumBreakdownRow';
  const { 
    label,
    price,
    suffix,
    bold = false,
    textValue = '',
    showSecondColumn = false
  } = props;

  const subHeadingClassName = [
    `${className}__label`,
    bold && `${className}__label--bold`
  ].filter(Boolean).join(' ');

  const getPrice = () => {
    return price !== undefined ? (
      <div
        className={`${className}__price`}
        id={`PremiumBreakdownRow__${label}--price`}
      >
        {
          getFormattedCurrencyNumber(price)
        }
        {suffix}
      </div>
    ) : null;
  };

  const getText = () => {
    return textValue !== '' ? (
      <div
        className={`${className}__price`}
        id={`PremiumBreakdownRow__${label}--price`}
      >
        {textValue}
      </div>
    ) : null;
  };
    return (
      <div
        className={`${className}__rowContainer`}
        id={`PremiumBreakdownRow__${label}`}
      >
        <div
          className={subHeadingClassName}
          id={`PremiumBreakdownRow__${label}--label`}
          style={showSecondColumn ? {
            width: '100%'
          }: {}}
        >
          {label}
        </div>
        {!showSecondColumn && 
          <>
            {getPrice()}
            {getText()}
          </>
        }
      </div>
    );
};

PremiumBreakdownRow.propTypes = {
  price: PropTypes.number
};

export default PremiumBreakdownRow;
